import React from 'react';
import produce from 'immer';
import { BehaviorEventRow } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/event-row';
import { useBehaviorsList } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/behaviors-list';
import { RetentionQuerySettingsReact } from 'common/query-builder/query-entry-section/row-types/metric-entry/metrics/retention/retention-query-settings';
import { getRetentionCountingMethod } from 'common/query-builder/query-entry-section/row-types/metric-entry/metrics/retention/utils';
import { RetentionQuerySettingsUpdate } from 'common/query-builder/query-entry-section/row-types/metric-entry/metrics/retention/types';
import { MetricType } from 'common/types/reports/bookmark';
import type { RowProps } from '../catalog';
import styles from './index.module.styl';
import { RetentionCriteria } from './retention-criteria';
export function RetentionBehaviorDefinition(props: RowProps) {
  const {
    behaviors,
    handleUpdateBehavior,
    handleDuplicateBehavior
  } = useBehaviorsList(props.entry!, props.updateEntry);
  const handleSettingsChanged = (update: RetentionQuerySettingsUpdate) => {
    const updatedEntry = produce(props.entry, draft => {
      draft.behavior.retentionUnboundedMode = update.unboundedMode;
      draft.measurement.retentionCumulative = Boolean(update.retentionCumulative);
    });
    props.updateEntry(updatedEntry);
  };
  return <div className={styles.retentionBehavior} data-sentry-component="RetentionBehaviorDefinition" data-sentry-source-file="behavior-definition.tsx">
      {behaviors.map((subBehavior, index) => {
      return <BehaviorEventRow {...props} behavior={subBehavior} suffixLabel={index === 0 ? " then" : null} onDuplicate={() => handleDuplicateBehavior(index)} onSelect={behavior => handleUpdateBehavior(index, behavior)} />;
    })}
      {props.entry.behavior.type === MetricType.Retention && <RetentionCriteria {...props} />}

      {props.entry.behavior.type === MetricType.RetentionFrequency && <RetentionQuerySettingsReact countingMethod={getRetentionCountingMethod(props.entry)} onChange={handleSettingsChanged} retentionType={props.entry.behavior.retentionType} />}
    </div>;
}